
import { numberRequiredSchema, select2RequiredSchema, stringLengthSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const goalFormSchema = object().shape({
	discipline_id: numberRequiredSchema,
	area_id: select2RequiredSchema,
	goal_id: select2RequiredSchema,
	goal_details: stringLengthSchema(500)
	// context_id: select2RequiredSchema,
	// goal_description: stringRequiredSchema,
	// goal_notes: stringSchema(),
});

export default goalFormSchema;